export const NAVIGATION_REQUESTED = 'navigation/NAVIGATION_REQUESTED';
export const NAVIGATION = 'navigation/NAVIGATION';
export const NAVIGATION_ERROR = 'navigation/NAVIGATION_ERROR';
export const NAVIGATION_TOGGLE_SEARCH = 'navigation/NAVIGATION_TOGGLE_SEARCH';
export const NAVIGATION_SET_ACTIVE_ITEM = 'navigation/NAVIGATION_SET_ACTIVE_ITEM';
